/**
 * <s-card-video> plays a product card's muted looping video only while the card
 * is near the viewport, and pauses it otherwise. Respects reduced motion by
 * leaving the poster frame in place.
 */
class CardVideoElement extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.video.muted = true;
    this.video.playsInline = true;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && !this.reducedMotion.matches) {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        }
      },
      { rootMargin: '200px' },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('s-card-video')) {
  customElements.define('s-card-video', CardVideoElement);
}
